<template>
	<section>
		<AsiContentContainer no-bottom-margin>
			<CustomerItemList v-if="item !== null" :item-model="item"/>
		</AsiContentContainer>
	</section>
</template>

<script lang="ts">
	import {Vue, Component, Prop} from 'vue-property-decorator';
	import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
	import AttachmentList from "@/components/attachment/AttachmentList.vue";
	import CustomerItemList from "@/components/customer-item/admin/CustomerItemList.vue";
	import {IItemAdmin} from "@/models/item/ItemAdminModels";

	@Component({
		components: {CustomerItemList, AttachmentList, AsiContentContainer}
	})
	export default class ItemTabCustomerItems extends Vue {

		@Prop({required: true})
		public item!: IItemAdmin | null;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;


	}
</script>


<style scoped lang="scss">

</style>
